<template>
  <ExActionsPopUp
    :value="show"
    headline="Move Checkpoint"
    :icon="'checkpoint_pass'"
    :htmlInfo="info"
    :primary="true"
    actionLabel="Move"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onMove')"
    @input="$emit('onClose')"
    data-testid="drop-to-move-checkpoint-popup"
    :backgroundPatternIconPosition="'0px 0px'"
    :backgroundPatternIconSize="'216px 216px'"
    :applyBorderClass="true"
    :width="600"
  />
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  checkpointName: {
    type: String,
    default: "",
  },
  responsibilityName: {
    type: String,
    default: "",
  },
});

defineEmits(["onMove", "onClose"]);

const info = computed(() => {
  const checkpoint = props.checkpointName || "this checkpoint";
  const responsibility = props.responsibilityName || "the selected responsibility";
  return `<div style="max-width: 260px; margin: 0 auto; margin-top: 26px;">You are about to move checkpoint<br><strong>${checkpoint}</strong><br>to responsibility<br><strong>${responsibility}</strong></div>`;
});
</script>
